import script from "./FaceImageSlots.vue?vue&type=script&setup=true&lang=js"
export * from "./FaceImageSlots.vue?vue&type=script&setup=true&lang=js"

import "./FaceImageSlots.vue?vue&type=style&index=0&id=4edd30ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4edd30ba"]])

export default __exports__